import { render, staticRenderFns } from "./CampaignSlider.vue?vue&type=template&id=347a8ed9"
import script from "./CampaignSlider.vue?vue&type=script&lang=js"
export * from "./CampaignSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports